import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import {GralMonService, PageBusquedaObject, GralMon} from '../gral-mon.service';
import { LoginService } from '../../../login/login.service';

@Component({
  selector: 'app-catalogo-gral-mon',
  templateUrl: './catalogo-gral-mon.component.html',
  styleUrls: ['./catalogo-gral-mon.component.css'],
  preserveWhitespaces: true
})
export class CatalogoGralMonComponent implements OnInit {

  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  items: GralMon[];
  rotate: any;
  cargado: boolean;

  @ViewChild('descripcion') descripcion: ElementRef;
  //@ViewChild('clave') clave: ElementRef;

  constructor(
    private router: Router,
    private monService: GralMonService,
    public loginService: LoginService
  ) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
  }

  ngOnInit(): void {
    this.cargarCatalogo();
  }

  cargarCatalogo() {
    this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa as number;
    this.mostrarMensajeCarga();
    this.monService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        console.log('this.items', this.items);
        this.totalItems = response.contenido.totalElements;
        this.cerrarMensajeCarga();
      }, err => {
      this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }

  eliminar(dtoDelete: GralMon): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.monService.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  sortearPor(columnName: any): void {
    console.log('columnName   ', columnName);
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 0;
    this.descripcion.nativeElement.value = '';
    //this.clave.nativeElement.value = '';
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      showConfirmButton: false,
      timerProgressBar: true,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }

}
